module.exports = __webpack_public_path__ + "img/phone.69428574.png";